import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter as Router } from 'react-router-dom';
import { SWRConfig } from 'swr';
import axios from 'axios';
import { AuthProvider } from 'react-auth-kit';
import { ContextProvider } from './context/GlobalContext';
import App from './App';
import LoadingPanel from './components/common/LoadingPanel';
import ErrorBoundary from './components/common/ErrorBoundary';

// Module-level request interceptor registered before any render/fetch.
// SWR runs with suspense:true, so data fetches fire during the very first
// render (before App's effect-based interceptors mount). This guarantees the
// current JWT is attached to the `authenticate` header on every request,
// reading it directly from where react-auth-kit persists it (sessionStorage
// keys "_auth" and "_auth_type"), so no request can go out unauthenticated.
axios.interceptors.request.use((config) => {
  try {
    const token = window.sessionStorage.getItem('_auth');
    const tokenType = window.sessionStorage.getItem('_auth_type');
    if (token) {
      config.headers = {
        ...config.headers,
        authenticate: tokenType ? `${tokenType} ${token}` : `Bearer ${token}`,
      };
    }
  } catch {
    // ignore storage access issues; request proceeds with existing headers
  }
  return config;
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <SWRConfig
    value={{
      fetcher: (...args) => axios.get(...args).then((res) => res.data),
      suspense: true,
    }}
  >
    <ErrorBoundary>
      <Suspense height="100%" fallback={<LoadingPanel />}>
        <Router>
          <AuthProvider authType="sessionStorage" authName="_auth">
            <ContextProvider>
              <App />
            </ContextProvider>
          </AuthProvider>
        </Router>
      </Suspense>
    </ErrorBoundary>
  </SWRConfig>
);
